import _classCallCheck from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Matrix\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Matrix\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import { createDefaultStyle, DEFAULT_OPTIONS } from './defaults';
import { formatValue } from './formatValue';
import { calculatePosition } from './position';
/**
 * The tooltip handler class.
 */

export var Handler =
/*#__PURE__*/
function () {
  /**
   * Create the tooltip handler and initialize the element and style.
   *
   * @param options Tooltip Options
   */
  function Handler(options) {
    _classCallCheck(this, Handler);

    this.options = Object.assign(Object.assign({}, DEFAULT_OPTIONS), options);
    var elementId = this.options.id; // bind this to call

    this.call = this.tooltipHandler.bind(this); // prepend a default stylesheet for tooltips to the head

    if (!this.options.disableDefaultStyle && !document.getElementById(this.options.styleId)) {
      var style = document.createElement('style');
      style.setAttribute('id', this.options.styleId);
      style.innerHTML = createDefaultStyle(elementId);
      var head = document.head;

      if (head.childNodes.length > 0) {
        head.insertBefore(style, head.childNodes[0]);
      } else {
        head.appendChild(style);
      }
    } // append a div element that we use as a tooltip unless it already exists
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion


    this.el = document.getElementById(elementId);

    if (!this.el) {
      this.el = document.createElement('div');
      this.el.setAttribute('id', elementId);
      this.el.classList.add('vg-tooltip');
      document.body.appendChild(this.el);
    }
  }
  /**
   * The tooltip handler function.
   */


  _createClass(Handler, [{
    key: "tooltipHandler",
    value: function tooltipHandler(handler, event, item, value) {
      // console.log(handler, event, item, value);
      // hide tooltip for null, undefined, or empty string values
      if (value == null || value === '') {
        this.el.classList.remove('visible', "".concat(this.options.theme, "-theme"));
        return;
      } // set the tooltip content


      this.el.innerHTML = formatValue(value, this.options.sanitize, this.options.maxDepth); // make the tooltip visible

      this.el.classList.add('visible', "".concat(this.options.theme, "-theme"));

      var _calculatePosition = calculatePosition(event, this.el.getBoundingClientRect(), this.options.offsetX, this.options.offsetY),
          x = _calculatePosition.x,
          y = _calculatePosition.y;

      this.el.setAttribute('style', "top: ".concat(y, "px; left: ").concat(x, "px"));
    }
  }]);

  return Handler;
}();